var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_vm._l((_vm.lines),function(line,i){return [_c('segmented-content',{attrs:{"content":line}}),(i < _vm.lines.length - 1)?_c('br'):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }